// extracted by mini-css-extract-plugin
export default {"required":"EditInsightBoardTitle_required__L1i1S"};